/**
 * The name the Add menu gives its design-system group — "Duro", or an
 * uploaded design system's own name — set by the app, which knows the site's
 * active design system (the editor does not).
 */
import { useSyncExternalStore } from "react";

let current = "Design system";
const listeners = new Set<() => void>();

export function setPaletteDesignSystemName(name: string): void {
  if (name === current) return;
  current = name;
  for (const l of listeners) l();
}

export function usePaletteDesignSystemName(): string {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
    () => current,
  );
}
